<template>
  <div>
    <label
      class="grey--text text--darken-4 text-body-2 font-weight-medium"
      :for="label"
    >
      {{ title }}
    </label>

    <v-btn-toggle
      v-on="$listeners"
      v-bind="$attrs"
      v-model="model"
      class="rounded-lg mt-1 grid-list-switch"
      :color="model ? 'primary' : 'error'"
      mandatory
    >
      <v-btn height="40px" :value="1">
        <div class="text-none">Sim</div>
      </v-btn>

      <v-btn height="40px" :value="0">
        <div class="text-none">Não</div>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: {
      required: false,
    },
  },
  data: () => ({
    label: "",
  }),
  computed: {
    model: {
      get() {
        return this.value || 0;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-list-switch {
  display: grid;
  gap: 0;
  grid-template-columns: 1fr 1fr;
  width: 100%;
}
</style>
